import apply from "./_apply.js";
var nativeMax = Math.max;
function overRest(func, start, transform) {
  return start = nativeMax(start === void 0 ? func.length - 1 : start, 0), function() {
    for (var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length); ++index < length; )
      array[index] = args[start + index];
    index = -1;
    for (var otherArgs = Array(start + 1); ++index < start; )
      otherArgs[index] = args[index];
    return otherArgs[start] = transform(array), apply(func, this, otherArgs);
  };
}
export {
  overRest as default
};
//# sourceMappingURL=_overRest.js.map
